import {Component, OnInit, OnDestroy} from '@angular/core';
import {Router} from '@angular/router';
import {MessageService} from '../message.service';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {RestApiService} from '../rest-api.service';
import {Filters, Formatters} from 'angular-slickgrid';
import {NotifierService} from 'angular-notifier';
import {Subscription} from 'rxjs';

@Component({
    selector: 'app-support-group-specific-url',
    templateUrl: './support-group-specific-url.component.html',
    styleUrls: ['./support-group-specific-url.component.css']
})
export class SupportGroupSpecificUrlComponent implements OnInit, OnDestroy {
    clientName: string;
    description: string;
    totalData = 0;
    show: boolean;
    selected: number;
    respObject: any;
    urlSelected: number;
    urlArr = [];
    url: string;
    add: boolean;
    del: boolean;
    edit: boolean;
    view: boolean;
    displayData: any;
    isError = false;
    errorMessage: string;
    nextOffset: number;
    previousOffset: number;
    pageSize: number;
    paginationType: string;
    page_no: number;
    totalPage: number;
    clientId: number;
    private baseFlag: any;
    private adminAuth: Subscription;
    private notifier: NotifierService;
    offset: number;
    clients = [];
    clientSelected: number;
    isAdmin: boolean;
    isDashboard: boolean;
    dataLoaded: boolean;
    support_group = [];
    sgroupSelected = [];
    groupSelectedstr: string;
    urlName: string;
    showurl: boolean;
    private userAuth: Subscription;
    ticketSelected: number;
    tickets = [];

    constructor(private _rest: RestApiService, private messageService: MessageService,
                private route: Router, private modalService: NgbModal, notifier: NotifierService) {
        this.notifier = notifier;
        this.messageService.getCellChangeData().subscribe(item => {
            switch (item.type) {
                case 'change':
                    if (!this.messageService.edit) {
                        this.notifier.notify('error', 'You do not have edit permission');
                    } else {
                        if (confirm('Are you sure?')) {
                        }
                    }
                    break;
                case 'delete':
                    if (!this.messageService.del) {
                        this.notifier.notify('error', 'You do not have delete permission');
                    } else {
                        if (confirm('Are you sure?')) {
                            // console.log(JSON.stringify(item));
                            this._rest.deleteSupportGroupSpecificUrl({
                                user_id: this.messageService.getUserId(),
                                id: item.id
                            }).subscribe((res) => {
                                this.respObject = res;
                                // console.log(JSON.stringify(this.respObject));
                                if (this.respObject.success) {
                                    this.messageService.sendAfterDelete(item.id);
                                    this.notifier.notify('success', 'URL Deleted successfully');
                                } else {
                                    this.notifier.notify('error', this.respObject.errorMessage);
                                }
                            }, (err) => {
                                this.notifier.notify('error', this.messageService.SERVER_ERROR);
                            });
                        }
                    }
                    break;
            }
        });
    }

    ngOnInit() {
        this.showurl = false;
        this.ticketSelected = 0;
        this.urlSelected = 0;
        this.groupSelectedstr = '';
        this.sgroupSelected = [];
        this.dataLoaded = false;
        this.nextOffset = 0;
        this.previousOffset = 0;
        this.pageSize = this.messageService.pageSize;
        this.page_no = 0;
        this.totalPage = 0;
        this.paginationType = 'next';
        this.displayData = {
            pageName: 'Maintain Support Group Specific URL',
            openModalButton: 'Add URL',
            breadcrumb: 'Support Group Specific URL',
            folderName: 'All Support Group Specific URL',
            tabName: 'Support Group Specific URL'
        };
        const columnDefinitions = [
            {
                id: 'delete',
                field: 'id',
                excludeFromHeaderMenu: true,
                formatter: Formatters.deleteIcon,
                minWidth: 30,
                maxWidth: 30,
            }, {
                id: 'urlkey', name: 'URL Key', field: 'url_key', sortable: true, filterable: true
            }, {
                id: 'url', name: 'URL', field: 'url', sortable: true, filterable: true
            }, {
                id: 'ticket_type', name: 'Ticket Type', field: 'ticket_type', sortable: true, filterable: true
            }, {
                id: 'spprtGrp', name: 'Support Group', field: 'supportGroup', sortable: true, filterable: true
            }
        ];
        this.messageService.setColumnDefinitions(columnDefinitions);
        if (this.messageService.clientId) {
            this.clientId = this.messageService.clientId;
            this.baseFlag = this.messageService.baseFlag;
            this.onPageLoad();
        } else {
            this.userAuth = this.messageService.getClientUserAuth().subscribe(auth => {
                this.view = auth[0].viewFlag;
                this.add = auth[0].addFlag;
                this.edit = auth[0].editFlag;
                this.del = auth[0].deleteFlag;
                this.clientId = auth[0].clientId;
                this.baseFlag = auth[0].baseFlag;
                this.onPageLoad();
            });
        }
    }

    onPageLoad() {
        console.log('user' + this.messageService.getUserId());

        this.showurl = false;
        this._rest.getSupportGroupByClientId(this.clientId).subscribe((res1) => {
            this.respObject = res1;
            if (this.respObject.success) {
                this.support_group = this.respObject.details;
            } else {
                this.isError = true;
                this.errorMessage = this.respObject.errorMessage;
            }
        }, (err) => {
            this.isError = true;
            this.errorMessage = this.messageService.SERVER_ERROR;
        });

        this._rest.getTicketType(this.clientId).subscribe((res1) => {
            this.respObject = res1;
            if (this.respObject.success) {
                this.isError = false;
                this.respObject.details.unshift({id: 0, name: 'Select Ticket Type'});
                this.tickets = this.respObject.details;
                this.ticketSelected = 0;
            } else {
                this.notifier.notify('error', this.respObject.errorMessage);
            }
        }, (err) => {
            this.notifier.notify('error', JSON.stringify(err));
        });

        this._rest.getClietSpecificUrl(this.clientId).subscribe((res) => {
            this.respObject = res;
            if (this.respObject.success) {
                this.respObject.details.unshift({id: 0, name: 'Select URL key'});
                this.urlArr = this.respObject.details;
                console.log('.............' + JSON.stringify(this.urlArr));
            } else {
                this.notifier.notify('error', this.respObject.errorMessage);
            }
        }, (err) => {
            this.notifier.notify('error', JSON.stringify(err));
        });
        this.getTableData();

    }

    openModal(content) {
        this.showurl = false;
        this.groupSelectedstr = '';
        this.sgroupSelected = [];
        if (!this.messageService.add) {
            this.notifier.notify('error', 'You do not have add permission');
        } else {
            this.isError = false;
            this.clientSelected = 0;
            this.urlSelected = 0;
            this.url = '';
            this.isAdmin = false;
            this.isDashboard = false;
            this.modalService.open(content, {size: 'sm'}).result.then((result) => {
            }, (reason) => {

            });
        }

    }

    changeRouting(path: string) {
        this.messageService.changeRouting(path);
    }

    save() {
        this.groupSelectedstr = this.sgroupSelected.toString();
        const data = {
            clientId: this.clientId,
            clientUrlid: this.urlSelected,
            SuppArray: this.sgroupSelected,
            ticketTypeId: this.ticketSelected,
            createdBy: this.messageService.getUserId()
        };
        // console.log('data' + JSON.stringify(data));
        if (!this.messageService.isBlankField(data) && (this.sgroupSelected.length !== 0)) {
            this._rest.addSupportGroupSpecificUrl(data).subscribe((res) => {
                this.respObject = res;
                if (this.respObject.success) {
                    this.nextOffset = 0;
                    this.page_no = 0;
                    this.getTableData();
                    this.isError = false;
                    this.showurl = false;
                    this.sgroupSelected = [];
                    this.groupSelectedstr = '';
                    this.clientSelected = 0;
                    this.urlSelected = 0;
                    this.isAdmin = false;
                    this.isDashboard = false;
                    this.url = '';
                    this.notifier.notify('success', 'Inserted Successfully');
                } else {
                    this.isError = true;
                    this.errorMessage = this.respObject.errorMessage;
                }
            }, (err) => {
                this.isError = true;
                this.errorMessage = this.messageService.SERVER_ERROR;
            });
        } else {
            this.isError = true;
            this.errorMessage = this.messageService.BLANK_ERROR_MESSAGE;
        }
    }

    getTableData() {
        if (!this.messageService.view) {
            this.notifier.notify('error', 'You do not have view permission');
        } else {
            this.getData({'offset': this.nextOffset, 'paginationType': ''});
        }
    }

    isEmpty(obj) {
        for (const key in obj) {
            if (obj.hasOwnProperty(key)) {
                return false;
            }
        }
        return true;
    }

    onUrlKeyChange(selectedIndex: any) {
        this.url = this.urlArr[selectedIndex].url;
        if (this.urlSelected !== 0) {
            this.showurl = true;
        } else {
            this.showurl = false;
        }
    }


    getData(paginationObj) {
        const offset = paginationObj.offset;
        const paginationType = paginationObj.paginationType;
        this.dataLoaded = false;
        console.log(this.clientId)
        this._rest.getSupportGroupSpecificUrl(offset, this.pageSize, paginationType, this.clientId).subscribe((res) => {
            this.respObject = res;
            // console.log("getdata"+JSON.stringify(this.respObject));
            this.executeResponse(this.respObject, offset, paginationType);
        }, (err) => {
            this.notifier.notify('error', this.messageService.SERVER_ERROR);
        });
    }

    executeResponse(respObject, offset, paginationType) {
        if (respObject.success) {
            this.dataLoaded = true;
            if (offset === 0) {
                this.totalData = respObject.details.totalData[0].count;
                this.totalPage = respObject.details.totalPage;
                if (this.totalPage === 0) {
                    this.totalPage = 1;
                }
            }
            if (!this.isEmpty(respObject.details.dataObj)) {
                const data = respObject.details.dataObj;
                this.nextOffset = respObject.details.nextOffset;
                this.offset = respObject.details.nextOffset;
                this.previousOffset = respObject.details.previousOffset;
                this.messageService.setTotalData(this.totalData);
                this.messageService.setGridData(data);
                // ----------------------------------------------
                if (offset !== 0) {
                    const totalCount = this.totalData;
                    const divRes = totalCount / this.pageSize;
                    const remainder = totalCount % this.pageSize;
                    if (remainder === 0) {
                        this.totalPage = parseInt(String(divRes), 10);
                    } else {
                        this.totalPage = parseInt(String(divRes), 10) + 1;
                    }
                }
                // ------------------------------------------------
                if (paginationType === 'next') {
                    this.page_no = this.page_no + 1;
                } else if (paginationType === 'prev') {
                    this.page_no = this.page_no - 1;
                } else if (paginationType === '' && this.page_no === 0) {
                    this.page_no = this.page_no + 1;
                }
                if (this.totalData <= this.pageSize * this.page_no) {
                    this.nextOffset = 0;
                }
            } else if (this.isEmpty(respObject.details.dataObj) && paginationType === 'next') {
                this.nextOffset = 0;
            } else if (this.isEmpty(respObject.details.dataObj) && paginationType === 'prev') {
                this.previousOffset = 0;
            } else if (paginationType === '' && this.page_no === 0) {
                this.page_no = this.page_no + 1;
            }
        } else {
            this.notifier.notify('error', respObject.errorMessage);
        }
    }

    onPageSizeChange(value: any) {
        this.page_no = 0;
        this.nextOffset = 0;
        this.pageSize = value;
        this.getData({'offset': this.nextOffset, 'paginationType': ''});
    }

    ngOnDestroy(): void {
        if (this.adminAuth) {
            this.adminAuth.unsubscribe();
        }
    }

}
